import { render, staticRenderFns } from "./PlayRoundId.vue?vue&type=template&id=a9000230&"
import script from "./PlayRoundId.vue?vue&type=script&lang=js&"
export * from "./PlayRoundId.vue?vue&type=script&lang=js&"
import style0 from "./PlayRoundId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports